import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import {PlateRecordDetailModalProps} from 'samples/plate-maps/plate-record/PlateRecordDetailModal';
import PlateMapViewDetailsButton from 'samples/plate-maps/PlateMapViewDetailsButton';
import {FONT_PROXIMA_TITLE} from 'styles/FontConstants';

export interface PlateMapSidebarMetadataProps {
  metadata: Array<{label: string; content: JSX.Element}>;
  plateRecordDetailModalProps: PlateRecordDetailModalProps;
  viewDetailsAnalyticsMetadata: AnalyticsEventMetadata;
}

export default function PlateMapSidebarMetadata({
  metadata,
  plateRecordDetailModalProps,
  viewDetailsAnalyticsMetadata,
}: PlateMapSidebarMetadataProps): JSX.Element {
  return (
    <>
      {metadata.length > 0 && (
        <div className={css(styles.metadata)}>
          {metadata.map(({label, content: value}, i) => (
            <div key={i}>
              <p className={css(styles.label)}>{label}</p>
              {value}
            </div>
          ))}
        </div>
      )}
      <PlateMapViewDetailsButton
        plateRecordDetailModalProps={plateRecordDetailModalProps}
        analyticsMetadata={viewDetailsAnalyticsMetadata}
      />
    </>
  );
}

const styles = StyleSheet.create({
  metadata: {
    marginBottom: '16px',
  },
  label: {
    ...FONT_PROXIMA_TITLE,
    marginBottom: '4px',
  },
});
